import { Component, HostListener, OnInit } from '@angular/core';
import { AutoFitTextDirective } from '../../shared/directives/auto-fit-text.directive';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [AutoFitTextDirective, NgIf],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  screenWidth!: number;

  constructor(private viewport: ViewportRuler) {}

  @HostListener('window:resize')
  onResize() {
    this.screenWidth = this.viewport.getViewportSize().width;
  }

  ngOnInit(): void {
    this.screenWidth = this.viewport.getViewportSize().width;
  }
}
